import React from 'react'
import { Form, Field, FormikProps } from 'formik'
import { IMediaType } from '../../types/mediaType'
import { StyledFormActionWrapper } from '../../layouts'
import {
  Button,
  H2,
  CustomTextField,
  DateAuthorFragment,
} from '../../components'

interface IMediaTypeForm {
  cancelAction?: () => void
  disableExtension?: boolean
  submitText: string
  editable?: boolean
  formikProps: FormikProps<IMediaType>
}

export const MediaTypeForm = ({
  submitText,
  disableExtension,
  cancelAction,
  editable = true,
  formikProps,
}: IMediaTypeForm) => (
  <>
    <H2 mb={4}>Enter metadata and save</H2>
    <Form>
      <Field
        name="title"
        label="Title"
        component={CustomTextField}
        disabled={!editable}
      />
      <Field
        name="mediaContentType"
        label="Media Content Type"
        component={CustomTextField}
        disabled={!editable}
      />
      <Field
        name="extension"
        label="Extension"
        component={CustomTextField}
        disabled={!!disableExtension || !editable}
      />
      <Field
        name="mimeType"
        label="Mime Type"
        component={CustomTextField}
        disabled={!editable}
      />
      <DateAuthorFragment {...formikProps.values} />
      <StyledFormActionWrapper>
        {!!cancelAction && (
          <Button id="cancel-button" onClick={cancelAction}>
            Cancel
          </Button>
        )}
        <Button
          id="submit-form-data"
          type="submit"
          variant="contained"
          color="primary"
          disabled={!formikProps.isValid || !editable}
        >
          {submitText}
        </Button>
      </StyledFormActionWrapper>
    </Form>
  </>
)
